import pluralize from 'pluralize';
import {ModalType, SnackbarType} from '@treez-ui/core/feedback/modals';
import {ButtonClass} from '@treez-ui/core/buttons';
import {clearSnackbar, showSnackbar} from '../actions/SnackbarActions';
import {closeFeedbackModal, openFeedbackModal} from '../actions/UserFeedbackActions';

const failedToRetrieveProductsTitle = 'Error retrieving Products';
const failedToRetrieveProductsText = 'There was an error loading products';

const {ERROR} = ModalType;

// Utility

// MODAL NEEDS WORK FOR THIS
// export const promptUserToBrowseBrandTreez = (
//     redirectToBrandTreez: () => void,
//     openProductForm: () => void,
// ) => {
//     return (dispatch) => {
//         dispatch(
//             openFeedbackModal(
//                 redirectToBrandTreez,
//                 '',
//                 {bodyElement: <BrowseBrandTreezPrompt
//                     redirectToBrandTreez = { redirectToBrandTreez }
//                     openProductForm = { openProductForm }
//                 />}
//             )
//         )
//     }
// }

export const confirmMerge = (onMerge: () => Promise<void>) => (dispatch) => {
    dispatch(
        openFeedbackModal(onMerge, 'Confirm Merge?', {
            bodyText: 'Are you sure you want to complete merge?',
            buttonClass: ButtonClass.BASIC,
            buttonText: 'Merge',
            cancelOption: true,
            onCancel: () => dispatch(closeUIModal()),
            type: ModalType.INFORMATION,
        })
    );
};
export const closeUIModal = () => {
    return (dispatch) => {
        dispatch(closeFeedbackModal());
    };
};

export const informUserErrorRetrievingBrandProduct = () => (dispatch) => {
    dispatch(
        openFeedbackModal(() => dispatch(closeUIModal()), `Error Retrieving Brand Product`, {
            bodyText: `There was an error retrieving the brand product to merge to`,
            type: ModalType.ERROR,
        })
    );
};

export const informUserErrorRetrievingStoreInfo = () => (dispatch) => {
    dispatch(
        openFeedbackModal(() => dispatch(closeUIModal()), `Error Retrieving Store Information `, {
            bodyText: `There was an error retrieving the products presence in the organization's stores`,
            type: ModalType.ERROR,
        })
    );
};

export const informUserErrorRetrievingProductsToMerge = () => (dispatch) => {
    dispatch(
        openFeedbackModal(() => dispatch(closeUIModal()), `Error Retrieving Products To Merge`, {
            bodyText: `There was an error retrieving the products to merge to`,
            type: ModalType.ERROR,
        })
    );
};

export const informUserOfErrorUnlinkingSuccess = () => {
    return (dispatch) => {
        dispatch(
            showSnackbar({
                onClose: () => dispatch(clearSnackbar()),
                type: SnackbarType.SUCCESS,
                content: `Product has been unlinked from BrandTreez.`,
            })
        );
    };
};

// Error Handling
export const informUserOfErrorAddingProducts = (errorMessage: any, numberOfProducts: number) => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(() => dispatch(closeUIModal()), 'An Error Has Occured', {
                bodyText: `There was an issue adding the ${pluralize('product', numberOfProducts)}:
                        ${errorMessage}`,
                type: ERROR,
            })
        );
    };
};

export const informUserOfErrorFetchingProducts = (errorMessage: string) => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(() => dispatch(closeUIModal()), failedToRetrieveProductsTitle, {
                type: ModalType.ERROR,
                bodyText: `${failedToRetrieveProductsText}:
                        ${errorMessage}`,
            })
        );
    };
};

export const informUserOfErrorFetchingOrganization = (errorMessage: string) => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(() => dispatch(closeUIModal()), 'Error Retrieving Organization', {
                bodyText: `There was an error retrieving organization details:
                        ${errorMessage}`,
                type: ModalType.ERROR,
            })
        );
    };
};

export const informUserOfErrorLinking = () => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(() => dispatch(closeUIModal()), 'Product Not Linked', {
                bodyText: 'There was an error linking the product to BrandTreez',
                type: ModalType.ERROR,
            })
        );
    };
};

export const informUserOfErrorUnlinking = () => {
    return (dispatch) => {
        dispatch(
            showSnackbar({
                onClose: () => dispatch(clearSnackbar()),
                type: SnackbarType.WARNING,
                content: `Unable to unlink product.`,
            })
        );
    };
};
export const informUserOfErrorExportingCSV = (errorMessage: string) => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(() => dispatch(closeUIModal()), 'Error Generating CSV file', {
                bodyText: `There was an error generating csv file:
                        ${errorMessage}`,
                type: ModalType.ERROR,
            })
        );
    };
};

// Action Confirmation
export const confirmProductsAdded = (numberProducts: number, numberOfCatalogs = 0) => {
    return (dispatch) => {
        dispatch(
            showSnackbar({
                onClose: () => dispatch(clearSnackbar()),
                autoHideDuration: 5000,
                type: SnackbarType.SUCCESS,
                content: `${numberProducts} ${pluralize('product', numberProducts)} added ${
                    numberOfCatalogs > 0 ? `to ${numberOfCatalogs} catalogs` : ''
                }`,
            })
        );
    };
};

export const confirmAddingExistingBrandProducts = (
    confirm: () => void,
    numOfDuplicates: number,
    numOfSelectedProducts: number
) => {
    return (dispatch) => {
        dispatch(
            openFeedbackModal(
                () => {
                    confirm();
                    dispatch(closeUIModal());
                },
                'Products already exist!',
                {
                    bodyText: `${numOfDuplicates} out of ${numOfSelectedProducts} selected products exists in the catalog already. Adding them again will result in duplicating product record. Proceed if you plan to create more than one product record linked to a single BrandTreez record.`,
                    buttonText: 'Proceed',
                    cancelOption: true,
                    onCancel: () => dispatch(closeUIModal()),
                    type: ModalType.WARNING,
                }
            )
        );
    };
};
